import React from 'react';

interface StatCardProps {
  value: string;
  label: string;
  sublabel: string;
}

const StatCard: React.FC<StatCardProps> = ({ value, label, sublabel }) => {
  return (
    <div className="border border-primary-gold bg-primary-black rounded-lg p-6 text-center hover:bg-primary-gold hover:bg-opacity-10 transition-colors duration-300">
      <div className="text-5xl font-bold text-primary-gold mb-2 font-display">
        {value}
      </div>
      <div className="text-white font-semibold uppercase tracking-wider text-sm mb-1">
        {label}
      </div>
      <div className="text-gray-400 text-xs uppercase tracking-wider">
        {sublabel}
      </div>
    </div>
  );
};

export default StatCard;
